import React, { Component } from 'react';
import glamorous from 'glamorous';
import Carousel from 'rcw-carousel';
import { Tree } from '@blueprintjs/core';
import { injectIntl } from 'react-intl';
import { get, toNumber, map, pick, isEmpty } from 'lodash';
import { DetailsBlockRow, DetailsBlock } from './details-block';
import messages from '../../utils/messages';
import noImagePng from '../../assets/images/no_image.png'

const switchDisplayKeys = [
  { key: 'desc', label: 'name' },
  { key: 'code', label: 'code' },
];

class DetailsRight extends Component {
  constructor(props) {
    super(props)
  };

  render() {
    const { recall, onRecallTagSelect, config } = this.props;

    const images = map(get(recall, 'images'), item => ({
      src: `${config.api}/getdocument.xqy?uri=${encodeURIComponent(get(item, 'imageUri'))}`,
      alt: get(item, 'alt.text', ''),
      onError: e => e.target.src = noImagePng
    }));

    const productCodes = get(recall, 'product.code');
    const productTags = map(get(recall, 'tags', []), tag => ({
      label: tag.value,
      id: tag.name,
      className: 'cursor-pointer',
      tag,
    }));

    const { formatMessage } = this.props.intl;

    return (
      <div className="col-sm-5">
        {!isEmpty(images) &&
        <div>
          <div style={{ height: '310px', width: '300px', margin: '0 auto' }}>
            <Carousel
              carouselOptions={{ lazyLoad: true }}
              images={images}
            />
          </div>
        </div>
        }
        {!isEmpty(productCodes) &&
        <DetailsBlock
          title={formatMessage(get(messages, 'recallCategorisation'))}
          tableClass="table-codes step10"
          switchDisplayKeys={switchDisplayKeys}
        >
          {({ displayKey }) => {
            return (
              map(productCodes, item => (
                <DetailsBlockRow
                  key={item.code}
                  label={formatMessage(get(messages, `${item.type}`))}
                  data={get(item, displayKey)}
                  type={'categoryLink'}
                  categoryType={item.type}
                  code={toNumber(item.code)}
                />
              ))
            )
          }}
        </DetailsBlock>}
        {!isEmpty(productTags) &&
        <DetailsBlock title="Tags" tableClass="table-merged step9">
          <tr>
            <glamorous.Td colSpan={2} css={{ padding: `0 !important` }}>
              <Tree
                contents={productTags}
                onNodeClick={node => onRecallTagSelect(node.tag)}
              />
            </glamorous.Td>
          </tr>
        </DetailsBlock>}
      </div>
    )
  }
}

export default injectIntl(DetailsRight);



// WEBPACK FOOTER //
// ./src/views/recall-details/details-right.js